$(function () {
  initProductCardHoldToConfirm($('.shop-product-container'));
});

// Hold a product tile for its details, tap for the extras popup; also used for tiles loaded later
function initProductCardHoldToConfirm($tiles) {
  $tiles.holdToConfirm({
    targetSelector: '.shop-product',
    svgSelector: '.ring-svg',
    totalDuration: 1250,

    onCancel: function ($wrap) {
      const productId = $wrap.data('product-id');
      // FIX: Using String comparison instead of Number (1) since .attr() returns a String
      const forcedProductExtraPopup =
        $wrap.attr('data-force-product-extra-popup') === '1';
      const hasProductExtra = $wrap.attr('data-has-product-extra') === '1';

      if (hasProductExtra && !forcedProductExtraPopup) {
        $(document).off('click', '.add-product');
        getClassicProductExtraModal(productId);

        setTimeout(() => {
          $(document).on('click', '.add-product', addProductClickHandler);
        }, 250);
      }
    },
    onComplete: function ($wrap) {
      const productId = $wrap.data('product-id');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/get-product-details',
        data: { product_id: productId },
        timeout: 10000,
      })
        .done(function (data) {
          if (data.html) {
            $('#content').append(data.html);
            $('#product-details-modal').modal('show');
          }
        })
        .fail(function (xhr) {
          if (xhr.responseJSON?.redirect_url) {
            window.location.href = xhr.responseJSON.redirect_url;
          }
        });
    },
  });
}
